import { render, staticRenderFns } from "./GeneralSpreadSelectorLive.vue?vue&type=template&id=27cc608c&scoped=true"
import script from "./GeneralSpreadSelectorLive.vue?vue&type=script&lang=js"
export * from "./GeneralSpreadSelectorLive.vue?vue&type=script&lang=js"
import style0 from "./GeneralSpreadSelectorLive.vue?vue&type=style&index=0&id=27cc608c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cc608c",
  null
  
)

export default component.exports